// 別注用の領収書発行ウィジェット（data-wu-widget="est-receipt-issue"）。本体は widget.ts。
//
// wuSiteResource2 の Shared/EstReceiptIssue.ts（AngularJS 1.x）の 4 ページ
// （1=/page/922 3=/page/271 4=/page/95 6=/page/207）を引き取ったもの。
// 通常版との違いは「発行後はメール送信ではなく PDF のダウンロード」で、それ以外は同じ流れ。
// 違いの一覧は text.ts の EST_TEXT と api.ts の estDownloadUrl の注記にある。
//
// 動的 import で読まれる。名前との対応は shared/registry.ts の LOADERS にある。

import { createReceiptWidget } from './widget'

export default createReceiptWidget('est')
